// extracted by mini-css-extract-plugin
module.exports = {"card":"EmptyCard-module__card--BTPY5","icon":"EmptyCard-module__icon--ZpK9d"};